<div class="slider-meta">
  <div class="row">
    <app-number [formGroup]="$safeNavigationMigration(model()?.meta?.formGroup)" [model]="$safeNavigationMigration(model()?.type?.data?.min)" [meta]="metaMin"></app-number>
  </div>
  <div class="row">
    <app-number [formGroup]="$safeNavigationMigration(model()?.meta?.formGroup)" [model]="$safeNavigationMigration(model()?.type?.data?.max)" [meta]="metaMax"></app-number>
  </div>
  <div class="row">
    <app-number [formGroup]="$safeNavigationMigration(model()?.meta?.formGroup)" [model]="$safeNavigationMigration(model()?.type?.data?.step)" [meta]="metaStep"></app-number>
  </div>
</div>
